const tmp = {};
//图片因为webpack无法直接设置本地地址，设置为空字符串
// 首页
tmp.home = {
    banner: [//banner
        {
            imgUrl: '../../assets/img/slides/1.jpg',
            title: '农业植保',
            subTitle: '稳定可靠，高效作业',
            desc: '采用最先进的无人机智能作业飞控管理系统，智能规划航线，药物喷洒精准，作业操控便捷。'
        },
        {
            imgUrl: '../../assets/img/slides/2.jpg',
            title: '水稻丰收',
            subTitle: '科技耕种，亩产量高',
            desc: '稻米外观品质好，饭香可口，食味佳，口感好，幼苗光合作用能力强，束缚水的含量高，移植后适应性和抗病力强。'
        },
        {
            imgUrl: '../../assets/img/slides/3.jpg',
            title: '玉米丰收',
            subTitle: '精选良种，合理密植',
            desc: '产量高，品质好，适应性强，栽培面积发展快。我们创造了玉米，玉米又造就了我们。'
        },
    ],
    service:[//产品展示
        {
            id: 1,
            imgUrl: '',
            title: '百香优9978',
            desc: '该品种属感光型三系杂交稻。桂南晚稻种植全生育期平均116.1天，比对照博优253短0.5天。,符合稻品种审定标准，通过审定。适宜桂南稻作区作晚稻和桂中稻作区适宜种植感光型品种的地区作晚稻种植。'
        },
        {
            id: 1,
            imgUrl: '',
            title: '百香优9978',
            desc: '该品种属感光型三系杂交稻。桂南晚稻种植全生育期平均116.1天，比对照博优253短0.5天。,符合稻品种审定标准，通过审定。适宜桂南稻作区作晚稻和桂中稻作区适宜种植感光型品种的地区作晚稻种植。'
        },
        {
            id: 1,
            imgUrl: '',
            title: '百香优9978',
            desc: '该品种属感光型三系杂交稻。桂南晚稻种植全生育期平均116.1天，比对照博优253短0.5天。,符合稻品种审定标准，通过审定。适宜桂南稻作区作晚稻和桂中稻作区适宜种植感光型品种的地区作晚稻种植。'
        },
        {
            id: 1,
            imgUrl: '',
            title: '百香优9978',
            desc: '该品种属感光型三系杂交稻。桂南晚稻种植全生育期平均116.1天，比对照博优253短0.5天。,符合稻品种审定标准，通过审定。适宜桂南稻作区作晚稻和桂中稻作区适宜种植感光型品种的地区作晚稻种植。'
        }
    ],
    news: [ //最新动态
        {
            imgUrl: '',
            date:{
                month: '03',
                day: '18'
            },
            title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
            desc: '2015年3月16日，自治区农业厅、自治区粮食局组织水稻育种、栽培、推广、稻米加工、市场营销等11名专家召开鉴评会议，按照国家及农业部有关标准，对24个参评样品分别进行理化指标评价和食味品质评分，综合评出“2014年度广西十大优质水稻品种”并进行公示。我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”。'
        },
        {
            imgUrl: '',
            date:{
                month: '03',
                day: '18'
            },
            title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
            desc: '2015年3月16日，自治区农业厅、自治区粮食局组织水稻育种、栽培、推广、稻米加工、市场营销等11名专家召开鉴评会议，按照国家及农业部有关标准，对24个参评样品分别进行理化指标评价和食味品质评分，综合评出“2014年度广西十大优质水稻品种”并进行公示。我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”。'
        },
        {
            imgUrl: '',
            date:{
                month: '03',
                day: '18'
            },
            title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
            desc: '2015年3月16日，自治区农业厅、自治区粮食局组织水稻育种、栽培、推广、稻米加工、市场营销等11名专家召开鉴评会议，按照国家及农业部有关标准，对24个参评样品分别进行理化指标评价和食味品质评分，综合评出“2014年度广西十大优质水稻品种”并进行公示。我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”。'
        }
    ]
}

// 公共
tmp.common = {
    footer:{
        link: [//网站地图
            {
                imgUrl: '',
                link: ''
            }
        ],
        news: [//底部资讯
            {
                id: 1,
                imgUrl: '',
                title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
                date: '2015-03-18'
            },
            {
                id: 1,
                imgUrl: '',
                title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
                date: '2015-03-18'
            },
            {
                id: 1,
                imgUrl: '',
                title: '【喜讯】我公司自主研发品种—“犇优317”成功入围“2014年度广西十大优质水稻品种”',
                date: '2015-03-18'
            }
        ]
    }
}

// 产品
tmp.product = [
    {
        id: 1,
        imgUrl: '/static/assets/product/1.jpg',
        name: '百香优9978'
    },
    {
        id: 2,
        imgUrl: '/static/assets/product/2.jpg',
        name: '百香优125'
    },
    {
        id: 2,
        imgUrl: '/static/assets/product/3.jpg',
        name: '畾优1068'
    },
    {
        id: 2,
        imgUrl: '/static/assets/product/4.jpg',
        name: '鑫丰优868'
    },
    {
        id: 2,
        imgUrl: '/static/assets/product/3.jpg',
        name: '畾优1068'
    },
    {
        id: 2,
        imgUrl: '/static/assets/product/4.jpg',
        name: '鑫丰优868'
    }
]
export default tmp;



// WEBPACK FOOTER //
// ./src/assets/js/tmp.js